/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './resolveDid.defs.js'
export { main as default } from './resolveDid.defs.js'
